(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["engraving-preview"] && !Shopify.designMode) return;
  try {
    // MYCLUSIV: Auch nach Section-Austausch initialisieren und entfernte Instanzen abbauen.
  if (!customElements.get('myc-engraving-preview')) {
    customElements.define('myc-engraving-preview', class extends HTMLElement {
      connectedCallback() {
        if (this._destroy) return;

  'use strict';
  const SECTION_ID = this.dataset.section;
  const PRODUCT_ID = this.dataset.productId;
  const UI_ID = 'engraving-preview-ui-' + SECTION_ID;
  const HANDLER_KEY = '__EP_HANDLERS_' + SECTION_ID;
  // MYCLUSIV: Alte Controller vollständig abbauen, damit neue Produktkonfigurationen greifen.
  if (typeof window[HANDLER_KEY]?.destroy === 'function') window[HANDLER_KEY].destroy();
  let destroyed = false;
  const ui = document.getElementById(UI_ID);
  if (!ui) return;
  // --- Texte ---
  let context = {};
  try { context = JSON.parse(this.querySelector('[data-preview-context]')?.textContent || '{}'); } catch (_) {}
  const I18N = context.i18n || {};
  const FALL = {
    preview: 'Vorschau anzeigen',
    update: 'Vorschau aktualisieren',
    close: 'Vorschau schließen',
    hint: '* Geringfügige optische Abweichungen können auftreten. Bitte beachte, dass Emojis nicht in Farbe graviert werden.',
    outdated: 'Vorschau nicht aktuell – bitte aktualisieren'
  };
  for (const k of Object.keys(FALL)) {
    if (!I18N[k] || !String(I18N[k]).trim()) I18N[k] = FALL[k];
  }
  const getUi = () => {
    const current = document.getElementById(UI_ID);
    return current?.dataset.productId === String(PRODUCT_ID) ? current : null;
  };
  const getBtn = () => getUi()?.querySelector('.engraving-preview-btn');
  const getLabel = () => getUi()?.querySelector('.engraving-preview-btn__label');
  function setButtonState(state) {
    const btn = getBtn();
    const label = getLabel();
    if (!btn || !label) return;
    if (state === 'create') {
      btn.dataset.state = 'create';
      btn.setAttribute('aria-expanded', 'false');
      label.textContent = I18N.preview;
    } else {
      btn.dataset.state = 'update';
      btn.setAttribute('aria-expanded', 'true');
      label.textContent = I18N.update;
    }
  }
  // --- Konfig ---
  let CFG = {};
  try {
    CFG = JSON.parse(this.querySelector('[data-preview-config]')?.textContent || '{}') || {};
  } catch(_) {
    CFG = {};
  }
  const COMMON   = CFG.common || {};
  const FILL     = COMMON.fill   || '#ffffff';
  const FAM      = COMMON.font   || "Nunito Sans, system-ui, -apple-system, BlinkMacSystemFont, 'Apple Color Emoji','Segoe UI Emoji','Segoe UI Symbol','Noto Color Emoji','PingFang SC','Hiragino Sans GB','Microsoft YaHei','Noto Sans CJK SC','Noto Sans Arabic','Amiri','Tajawal', sans-serif";
  function previewFont(stack) {
    return String(stack).split(',').map(part => {
      const family = part.trim().replace(/^['"]|['"]$/g, '');
      const match = context.themeFonts?.find(font => String(font.family).replace(/^['"]|['"]$/g, '') === family);
      return match ? JSON.stringify(match.alias) : part.trim();
    }).join(', ');
  }
  const WGT      = COMMON.weight || 700;
  const ALGN     = COMMON.align  || 'center';
  const QUALITY  = COMMON.quality || 0.92;
  // Modi (rückwärts-kompatibel)
  const LAYOUT_MODE = (COMMON.layoutMode || 'legacy');   // 'legacy' | 'natural'
  const OVERFLOW    = (COMMON.overflow   || 'visible');  // natural: 'visible'|'tail'|'both'
  const ANCHOR      = (COMMON.anchor     || 'center');   // natural: 'start'|'center'
  const COMMON_BASE = COMMON.base || null;
  // --- Basis-Helpers ---
  const DPR_CAP = 2;
  const dpr = () => Math.min(window.devicePixelRatio || 1, DPR_CAP);
  const initialHost = ui.closest('.shopify-section') || ui.parentElement;
  const hostSection = () => getUi()?.closest('.shopify-section') || initialHost;
  const productScope = () => getUi()?.closest('.product-info') || hostSection();
  const productFormId = () => productScope()?.querySelector('variant-picker')?.getAttribute('form-id') || '';
  const VARIANT_IDS = new Set((context.variantIds || []).map(String));
  const twoFrames = (cb) => requestAnimationFrame(() => requestAnimationFrame(cb));
  const prefersReducedMotion = () => {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; }
    catch(_) { return false; }
  };
  const smoothBehavior = () => prefersReducedMotion() ? 'auto' : 'smooth';
  // --- Variant helpers ---
  let latestVariant = activeVariantDataFromDom() || null;
  function activeVariantDataFromDom() {
    const script = productScope()?.querySelector('script[data-variant]');
    if (!script) return null;
    try { return JSON.parse(script.textContent || '{}'); }
    catch(_) { return null; }
  }
  const getActiveVariant = () => latestVariant || activeVariantDataFromDom() || null;
  const getActiveSku = () => (getActiveVariant()?.sku || '').trim();
  const getActiveFeaturedMediaId = () => getActiveVariant()?.featured_media?.id || context.featuredMediaId || null;
  // --- Gallery helpers (Prestige Product Gallery) ---
  function galleryComponent() {
    return hostSection().querySelector('product-gallery');
  }
  function galleryRoot() {
    return galleryComponent() || hostSection().querySelector('[data-media-gallery]') || hostSection();
  }
  function galleryCarousel() {
    return galleryComponent()?.carousel || galleryRoot()?.querySelector('.product-gallery__carousel') || null;
  }
  function visibleMedia() {
    return Array.from(galleryRoot()?.querySelectorAll('.product-gallery__media') || []).filter(el => !el.hasAttribute('hidden'));
  }
  function findVisibleMediaById(mediaId) {
    if (!mediaId) return null;
    return visibleMedia().find(el =>
      String(el.dataset?.mediaId || el.getAttribute('data-media-id')) === String(mediaId)
    ) || null;
  }
  function revealMedia(target) {
    if (!target) return;
    try {
      target.scrollIntoView({ behavior: smoothBehavior(), block: 'nearest', inline: 'start' });
    } catch(_) {}
  }
  async function goToActiveFeaturedMedia() {
    const mediaId = getActiveFeaturedMediaId();
    const carousel = galleryCarousel();
    if (mediaId && carousel?.cells?.length) {
      const index = carousel.cells.findIndex(el =>
        String(el.dataset?.mediaId || el.getAttribute('data-media-id')) === String(mediaId)
      );
      if (index > -1) {
        try {
          await carousel.select(index, { instant: true });
        } catch(_) {}
        return findVisibleMediaById(mediaId);
      }
    }
    return findVisibleMediaById(mediaId);
  }
  // --- Zuordnung: SKU -> Base-URL + Slots pro Base ---
  const SKU2BASE = new Map();
  const BASE2SLOTS = new Map();
  if (Array.isArray(CFG.groups)) {
    for (const g of CFG.groups) {
      if (!g || typeof g !== 'object') continue;
      const slotRef = Array.isArray(g.slots) ? g.slots.slice(0, 10) : [];
      const skus = Array.isArray(g.skus) ? g.skus : [];
      const registerBase = (baseUrl) => {
        if (baseUrl && !BASE2SLOTS.has(baseUrl)) BASE2SLOTS.set(baseUrl, slotRef);
      };
      if (g && typeof g.basesBySku === 'object' && g.basesBySku !== null) {
        for (const sku of skus) {
          const specificBase = g.basesBySku[sku] || g.base;
          SKU2BASE.set(String(sku), specificBase);
          registerBase(specificBase);
        }
      } else {
        for (const sku of skus) SKU2BASE.set(String(sku), g.base);
        registerBase(g.base);
      }
    }
  }
  const getSlotsForBase = (base) =>
    (BASE2SLOTS.get(base) || (Array.isArray(COMMON.slots) ? COMMON.slots : [])).slice(0, 10);
  const getBaseForActiveSku = () => SKU2BASE.get(getActiveSku()) || COMMON_BASE || null;
  // --- State & Cache ---
  const KEY = '__EP_' + SECTION_ID;
  const EP = window[KEY] = {
    wrap: null,
    img: null,
    closeBtn: null,
    hint: null,
    stageWasForced: null,
    mediaId: null,
    active: false,
    outdated: false,
    blobUrl: null,
    lastKey: ''
  };
  const imgCache = new Map();
  let renderNonce = 0;
  let busyNonce = 0;
  let mo = null;
  let observedRoot = null;
  let boundCarousel = null;
  let refreshFrame = null;
  let refreshVariantFromDom = false;

  // MYCLUSIV: Laufende Render abbrechen; spät eintreffende Bilder dürfen nichts überschreiben.
  function cancelRender() {
    renderNonce++;
    busyNonce = 0;
    const btn = getBtn();
    if (btn) btn.disabled = false;
  }
  const isCurrentRender = (nonce) => !destroyed && !!getUi() && nonce === renderNonce;
  function readTexts(limit = 10) {
    const L = Math.max(1, Math.min(10, limit | 0));
    const hasAny = (arr) => arr.some(v => String(v || '').trim().length > 0);
    const host = productScope();
    if (!host) return [];
    // MYCLUSIV: Nur Felder dieses Produktbereichs lesen; ausgeblendete/deaktivierte ignorieren.
    const legacy = [];
    let hasLegacyFields = false;
    for (let i = 1; i <= L; i++) {
      const el = host.querySelector('[id="' + i + '-customize"]');
      if (el) hasLegacyFields = true;
      legacy.push(el && !el.disabled && el.offsetParent !== null ? String(el.value || '').trim() : '');
    }
    if (hasLegacyFields) return hasAny(legacy) ? legacy : [];
    const fields = Array.from(host.querySelectorAll(
      'input[type="text"][name^="properties["], input:not([type])[name^="properties["], textarea[name^="properties["]'
    )).filter(el => !el.disabled && el.offsetParent !== null);
    const props = fields.slice(0, L).map(el => String(el.value || '').trim());
    while (props.length < L) props.push('');
    return hasAny(props) ? props : [];
  }
  async function loadImg(src) {
    // MYCLUSIV-OPTIMIERUNG: Auch laufende Bildladungen teilen; Fehler bleiben erneut versuchbar.
    if (imgCache.has(src)) return imgCache.get(src);
    const image = new Image();
    image.crossOrigin = 'anonymous';
    image.decoding = 'async';
    const pending = new Promise((resolve, reject) => {
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Preview image could not be loaded'));
      image.src = src;
    }).then(async loaded => {
      try { await loaded.decode?.(); } catch (_) {}
      return loaded;
    });
    imgCache.set(src, pending);
    try { return await pending; }
    catch (error) { imgCache.delete(src); throw error; }
  }
  // --- Overlay ---
  function attachToStage(stage) {
    if (!EP.wrap || !stage) return;
    if (EP.stageWasForced && EP.stageWasForced !== stage) {
      EP.stageWasForced.style.position = '';
      EP.stageWasForced = null;
    }
    if (EP.wrap.parentElement === stage) return;
    if (getComputedStyle(stage).position === 'static') {
      EP.stageWasForced = stage;
      stage.style.position = 'relative';
    }
    if (EP.wrap.parentElement !== stage) stage.appendChild(EP.wrap);
  }
  function ensureObserver() {
    const root = galleryRoot();
    if (!root || observedRoot === root) return;
    disconnectObserver();
    if (!('MutationObserver' in window)) return;
    observedRoot = root;
    mo = new MutationObserver(() => {
      if (EP.active) reattachOnly();
    });
    mo.observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden', 'data-media-id'] });
  }
  function disconnectObserver() {
    if (mo) {
      mo.disconnect();
      mo = null;
    }
    observedRoot = null;
  }
  function ensureOverlay() {
    if (!EP.wrap) {
      EP.mediaId = getActiveFeaturedMediaId();
      EP.wrap = document.createElement('div');
      EP.wrap.className = 'engraving-preview-wrap';
      EP.wrap.id = 'engraving-preview-overlay-' + SECTION_ID;
      EP.img = document.createElement('img');
      EP.img.className = 'engraving-preview-image';
      EP.img.alt = 'engraving preview';
      EP.img.decoding = 'async';
      EP.img.fetchPriority = 'low';
      EP.closeBtn = document.createElement('button');
      EP.closeBtn.type = 'button';
      EP.closeBtn.className = 'engraving-preview-close';
      EP.closeBtn.setAttribute('aria-label', I18N.close);
      EP.closeBtn.textContent = '×';
      EP.hint = document.createElement('div');
      EP.hint.className = 'engraving-preview-hint';
      EP.hint.textContent = I18N.hint;
      EP.wrap.append(EP.img, EP.closeBtn, EP.hint);
    }
    reattachOnly();
    ensureObserver();
  }
  function removeOverlay() {
    cancelRender();
    if (EP.wrap?.parentElement) EP.wrap.parentElement.removeChild(EP.wrap);
    if (EP.stageWasForced) {
      EP.stageWasForced.style.position = '';
      EP.stageWasForced = null;
    }
    if (EP.blobUrl) {
      URL.revokeObjectURL(EP.blobUrl);
      EP.blobUrl = null;
    }
    EP.active = false;
    EP.outdated = false;
    EP.lastKey = '';
    EP.mediaId = null;
    EP.wrap = null;
    EP.img = null;
    EP.closeBtn = null;
    EP.hint = null;
    setButtonState('create');
    disconnectObserver();
    document.dispatchEvent(new CustomEvent('engraving-preview:closed', {
      detail: { sectionId: SECTION_ID }
    }));
  }
  function markOutdated(flag) {
    EP.outdated = !!flag;
    if (EP.hint) EP.hint.textContent = EP.outdated ? I18N.outdated : I18N.hint;
    if (EP.wrap) EP.wrap.dataset.outdated = EP.outdated ? '1' : '';
    if (EP.active) setButtonState('update');
  }
  // --- Typografie/Rendering ---
  const HAS_SEG = typeof Intl !== 'undefined' && 'Segmenter' in Intl;
  const SEG = HAS_SEG ? new Intl.Segmenter(undefined, { granularity: 'grapheme' }) : null;
  const splitGraphemes = (s) => HAS_SEG ? Array.from(SEG.segment(s), x => x.segment) : Array.from(s);
  const splitWords = (s) => String(s).trim().split(/\s+/);
  const RE_RTL = /[\u0590-\u05FF\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/u;
  function measureGlyphs(ctx, text, trackPx, clusterMode, direction) {
    const segs = (clusterMode === 'word' || (clusterMode !== 'grapheme' && RE_RTL.test(text)))
      ? splitWords(text)
      : splitGraphemes(text);
    const items = (direction === 'rtl') ? segs.slice().reverse() : segs;
    const widths = items.map(ch => ctx.measureText(ch).width + (trackPx || 0));
    const total = widths.reduce((a, b) => a + b, 0);
    return { items, widths, total };
  }
  function resolveFontSizePx(slot, W) {
    if (typeof slot.fontSizePx === 'number') return slot.fontSizePx;
    if (typeof slot.fontSizePctW === 'number') return (slot.fontSizePctW / 100) * W;
    if (typeof COMMON.fontSizePx === 'number') return COMMON.fontSizePx;
    if (typeof COMMON.fontSizePctW === 'number') return (COMMON.fontSizePctW / 100) * W;
    return (5 / 100) * W;
  }
  function resolveTrackPx(slot, W) {
    if (typeof slot.letterSpacingPx === 'number') return slot.letterSpacingPx;
    if (typeof slot.letterSpacingPctW === 'number') return (slot.letterSpacingPctW / 100) * W;
    if (typeof COMMON.letterSpacingPx === 'number') return COMMON.letterSpacingPx;
    if (typeof COMMON.letterSpacingPctW === 'number') return (COMMON.letterSpacingPctW / 100) * W;
    return 0;
  }
  // --- LEGACY ---
  function drawTextArcLegacy(ctx, items, widths, total, opt) {
    const { cx, cy, r, a0, a1, inward, fontPx, fill, weight, family, scaleY = 1, rotateDeg = 0 } = opt;
    ctx.save();
    ctx.translate(cx, cy);
    if (rotateDeg) ctx.rotate((rotateDeg * Math.PI) / 180);
    if (scaleY !== 1) ctx.scale(1, scaleY);
    ctx.translate(-cx, -cy);
    ctx.font = `${weight} ${fontPx}px ${family}`;
    ctx.fillStyle = fill;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    const arcLen = Math.abs(a1 - a0) * r;
    const k = (total > 0 && arcLen > 0) ? (a1 - a0) / total : 0;
    let ang = a0;
    for (let i = 0; i < items.length; i++) {
      const w = widths[i];
      const mid = ang + (w * k) / 2;
      const x = cx + r * Math.cos(mid);
      const y = cy + r * Math.sin(mid);
      const rot = mid + (inward ? Math.PI / 2 : -Math.PI / 2);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rot);
      if (inward) ctx.scale(1, -1);
      ctx.fillText(items[i], 0, 0);
      ctx.restore();
      ang += w * k;
    }
    ctx.restore();
  }
  function bezierPoint(t, p0, p1, p2, p3) {
    if (p3) {
      const mt = 1 - t;
      return {
        x: mt * mt * mt * p0.x + 3 * mt * mt * t * p1.x + 3 * mt * t * t * p2.x + t * t * t * p3.x,
        y: mt * mt * mt * p0.y + 3 * mt * mt * t * p1.y + 3 * mt * t * t * p2.y + t * t * t * p3.y
      };
    }
    const mt = 1 - t;
    return {
      x: mt * mt * p0.x + 2 * mt * t * p1.x + t * t * p2.x,
      y: mt * mt * p0.y + 2 * mt * t * p1.y + t * t * p2.y
    };
  }
  function bezierTangent(t, p0, p1, p2, p3) {
    if (p3) {
      const mt = 1 - t;
      return {
        x: -3 * mt * mt * p0.x + 3 * (mt * mt - 2 * mt * t) * p1.x + 3 * (2 * mt * t - t * t) * p2.x + 3 * t * t * p3.x,
        y: -3 * mt * mt * p0.y + 3 * (mt * mt - 2 * mt * t) * p1.y + 3 * (2 * mt * t - t * t) * p2.y + 3 * t * t * p3.y
      };
    }
    return {
      x: 2 * (1 - t) * (p1.x - p0.x) + 2 * t * (p2.x - p1.x),
      y: 2 * (1 - t) * (p1.y - p0.y) + 2 * t * (p2.y - p1.y)
    };
  }
  function drawTextOnBezierLegacy(ctx, items, widths, total, opt) {
    const { P, fontPx, fill, weight, family, scaleY = 1, rotateDeg = 0, inward = false, samples = 250 } = opt;
    const pts = [{ t: 0, ...bezierPoint(0, P.p0, P.p1, P.p2, P.p3) }];
    const len = [0];
    for (let i = 1; i <= samples; i++) {
      const t = i / samples;
      const q = bezierPoint(t, P.p0, P.p1, P.p2, P.p3);
      const prev = pts[pts.length - 1];
      const dl = Math.hypot(q.x - prev.x, q.y - prev.y);
      pts.push({ t, ...q });
      len.push(len[len.length - 1] + dl);
    }
    const totalLen = len[len.length - 1] || 1;
    ctx.save();
    ctx.font = `${weight} ${fontPx}px ${family}`;
    ctx.fillStyle = fill;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    let curDist = (totalLen - total) / 2;
    for (let i = 0; i < items.length; i++) {
      const w = widths[i];
      const mid = curDist + w / 2;
      let idx = len.findIndex(L => L >= mid);
      if (idx < 0) idx = len.length - 1;
      const L0 = len[idx - 1] ?? 0;
      const L1 = len[idx];
      const ratio = L1 === L0 ? 0 : (mid - L0) / (L1 - L0);
      const t = ((pts[idx - 1]?.t ?? 0) * (1 - ratio)) + (pts[idx]?.t ?? 0) * ratio;
      const pt = bezierPoint(t, P.p0, P.p1, P.p2, P.p3);
      const tg = bezierTangent(t, P.p0, P.p1, P.p2, P.p3);
      const rot = Math.atan2(tg.y, tg.x) + (inward ? Math.PI : 0);
      ctx.save();
      ctx.translate(pt.x, pt.y);
      if (rotateDeg) ctx.rotate((rotateDeg * Math.PI) / 180);
      if (scaleY !== 1) ctx.scale(1, scaleY);
      ctx.rotate(rot);
      ctx.fillText(items[i], 0, 0);
      ctx.restore();
      curDist += w;
    }
    ctx.restore();
  }
  // --- NATURAL ---
  function drawTextArcNatural(ctx, items, widths, opt) {
    const { cx, cy, r, a0, a1, fontPx, fill, weight, family, inward = false, anchor = 'start', overflow = 'tail' } = opt;
    ctx.save();
    ctx.font = `${weight} ${fontPx}px ${family}`;
    ctx.fillStyle = fill;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    const arcLen = Math.abs(a1 - a0) * r;
    const total = widths.reduce((a, b) => a + b, 0);
    const angPerPx = (a1 - a0) / Math.max(1, arcLen);
    let ang = (anchor === 'center') ? (a0 + (arcLen - total) / 2 * angPerPx) : a0;
    for (let i = 0; i < items.length; i++) {
      const w = widths[i];
      const mid = ang + (w * angPerPx) / 2;
      if (overflow !== 'visible') {
        const tailOut = (a1 >= a0 && mid > a1) || (a1 < a0 && mid < a1);
        const headOut = (anchor === 'center' && ((a1 >= a0 && mid < a0) || (a1 < a0 && mid > a0)));
        if (overflow === 'tail' && tailOut) break;
        if (overflow === 'both' && (tailOut || headOut)) {
          ang += w * angPerPx;
          continue;
        }
      }
      const x = cx + r * Math.cos(mid);
      const y = cy + r * Math.sin(mid);
      const rot = mid + (inward ? Math.PI / 2 : -Math.PI / 2);
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(rot);
      if (inward) ctx.scale(1, -1);
      ctx.fillText(items[i], 0, 0);
      ctx.restore();
      ang += w * angPerPx;
    }
    ctx.restore();
  }
  function qPoint(t, p0, p1, p2) {
    const mt = 1 - t;
    return {
      x: mt * mt * p0.x + 2 * mt * t * p1.x + t * t * p2.x,
      y: mt * mt * p0.y + 2 * mt * t * p1.y + t * t * p2.y
    };
  }
  function qTangent(t, p0, p1, p2) {
    return {
      x: 2 * (1 - t) * (p1.x - p0.x) + 2 * t * (p2.x - p1.x),
      y: 2 * (1 - t) * (p1.y - p0.y) + 2 * t * (p2.y - p1.y)
    };
  }
  function drawTextOnBezierNatural(ctx, items, widths, opt) {
    const { P, fontPx, fill, weight, family, scaleY = 1, anchor = 'start', overflow = 'tail', samples = 360 } = opt;
    const pts = [{ t: 0, ...qPoint(0, P.p0, P.p1, P.p2) }];
    const lens = [0];
    for (let i = 1; i <= samples; i++) {
      const t = i / samples;
      const q = qPoint(t, P.p0, P.p1, P.p2);
      const prev = pts[i - 1];
      pts.push({ t, ...q });
      lens.push(lens[i - 1] + Math.hypot(q.x - prev.x, q.y - prev.y));
    }
    const L = lens[lens.length - 1] || 1;
    const total = widths.reduce((a, b) => a + b, 0);
    ctx.save();
    ctx.font = `${weight} ${fontPx}px ${family}`;
    ctx.fillStyle = fill;
    ctx.textBaseline = 'middle';
    ctx.textAlign = 'center';
    let cur = (anchor === 'center') ? (L - total) / 2 : 0;
    for (let i = 0; i < items.length; i++) {
      const w = widths[i];
      const mid = cur + w / 2;
      if (overflow !== 'visible') {
        const tailOut = mid > L;
        const headOut = (anchor === 'center' && mid < 0);
        if (overflow === 'tail' && tailOut) break;
        if (overflow === 'both' && (tailOut || headOut)) {
          cur += w;
          continue;
        }
      }
      const mm = Math.max(0, Math.min(L, mid));
      let k = lens.findIndex(v => v >= mm);
      if (k < 0) k = lens.length - 1;
      const L0 = lens[k - 1] ?? 0;
      const L1 = lens[k];
      const r = L1 === L0 ? 0 : (mm - L0) / (L1 - L0);
      const t = (pts[k - 1]?.t || 0) * (1 - r) + (pts[k]?.t || 0) * r;
      const pos = qPoint(t, P.p0, P.p1, P.p2);
      const tan = qTangent(t, P.p0, P.p1, P.p2);
      const ang = Math.atan2(tan.y, tan.x);
      ctx.save();
      ctx.translate(pos.x, pos.y);
      ctx.rotate(ang);
      ctx.scale(1, scaleY);
      ctx.fillText(items[i], 0, 0);
      ctx.restore();
      cur += w;
    }
    ctx.restore();
  }
  // --- Render nur per Button ---
  async function renderPreview(opts = { resetIfEmpty: false }) {
    const nonce = opts.nonce || ++renderNonce;
    if (!isCurrentRender(nonce)) return;
    busyNonce = nonce;
    const baseUrl = getBaseForActiveSku();
    if (!baseUrl) {
      if (opts.resetIfEmpty) removeOverlay();
      return;
    }
    const SLOTS = getSlotsForBase(baseUrl);
    const texts = readTexts(SLOTS.length || 10);
    if (!texts.length) {
      ensureOverlay();
      if (opts.resetIfEmpty) removeOverlay();
      return;
    }
    const key = [
      getActiveFeaturedMediaId(),
      baseUrl,
      SLOTS.length,
      texts.join('\n'),
      LAYOUT_MODE,
      OVERFLOW,
      ANCHOR
    ].join('|');
    if (EP.lastKey === key && EP.active && !EP.outdated) {
      ensureOverlay();
      busyNonce = 0;
      const cachedButton = getBtn();
      if (cachedButton) cachedButton.disabled = false;
      return;
    }
    EP.active = true;
    markOutdated(false);
    setButtonState('update');
    const btn = getBtn();
    if (btn) btn.disabled = true;
    let previewFontsReady = true;
    try {
      ensureOverlay();
      const base = await loadImg(baseUrl);
      if (!isCurrentRender(nonce)) return;
      if (document.fonts?.load) {
        const fonts = new Set(texts.map((text, index) => {
          const slot = SLOTS[index] || {};
          return `${slot.weight || WGT} 16px ${previewFont(slot.font || FAM)}`;
        }));
        let fontTimeoutId;
        try {
          const fontResults = await Promise.race([
            Promise.allSettled(Array.from(fonts, font =>
              Promise.resolve().then(() => document.fonts.load(font, texts.join('')))
            )),
            new Promise(resolve => {
              fontTimeoutId = setTimeout(() => resolve(null), 2000);
            })
          ]);
          previewFontsReady = fontResults !== null &&
            fontResults.every(result => result.status === 'fulfilled');
        } finally {
          clearTimeout(fontTimeoutId);
        }
        if (!isCurrentRender(nonce)) return;
      }
      const W = base.naturalWidth;
      const H = base.naturalHeight;
      const scale = dpr();
      const canvas = renderPreview.canvas || (renderPreview.canvas = document.createElement('canvas'));
      const ctx = canvas.getContext('2d');
      if (!ctx) throw new Error('Canvas 2D context is unavailable');
      const w = Math.round(W * scale);
      const h = Math.round(H * scale);
      if (canvas.width !== w) canvas.width = w;
      if (canvas.height !== h) canvas.height = h;
      let drawSrc = base;
      if (window.createImageBitmap) {
        try { drawSrc = await createImageBitmap(base); } catch(_) {}
      }
      try {
        if (!isCurrentRender(nonce)) return;
        ctx.setTransform(scale, 0, 0, scale, 0, 0);
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        ctx.drawImage(drawSrc, 0, 0, W, H);
      } finally {
        try { if (drawSrc !== base) drawSrc.close?.(); } catch (_) {}
      }
      texts.forEach((t, i) => {
        const s = SLOTS[i] || {};
        const fs = resolveFontSizePx(s, W);
        const track = resolveTrackPx(s, W);
        const dir = s.direction || 'ltr';
        const layout = (s.layoutMode || LAYOUT_MODE);
        const overflow = (s.overflow || OVERFLOW);
        const anchor = (s.anchor || ANCHOR);
        ctx.save();
        ctx.font = `${s.weight || WGT} ${fs}px ${previewFont(s.font || FAM)}`;
        const M = measureGlyphs(ctx, String(t), track, s.cluster || 'grapheme', dir);
        if (s.mode === 'arc') {
          const cx = (s.cxPct ?? 50) / 100 * W;
          const cy = (s.cyPct ?? 50) / 100 * H;
          const r = (s.radiusPctW ?? 30) / 100 * W;
          const a0 = ((s.startAngleDeg ?? -90) * Math.PI) / 180;
          const a1 = ((s.endAngleDeg ?? 90) * Math.PI) / 180;
          if (layout === 'legacy') {
            drawTextArcLegacy(ctx, M.items, M.widths, M.total, {
              cx, cy, r, a0, a1,
              inward: !!s.inward,
              fontPx: fs,
              fill: (s.fill || FILL),
              weight: (s.weight || WGT),
              family: previewFont(s.font || FAM)
            });
          } else {
            drawTextArcNatural(ctx, M.items, M.widths, {
              cx, cy, r, a0, a1,
              fontPx: fs,
              fill: (s.fill || FILL),
              weight: (s.weight || WGT),
              family: previewFont(s.font || FAM),
              inward: !!s.inward,
              anchor,
              overflow
            });
          }
        } else if (s.mode === 'bezier') {
          const P = {};
          ['p0', 'p1', 'p2', 'p3'].forEach(k => {
            if (s[k]) P[k] = { x: (s[k].xPct / 100) * W, y: (s[k].yPct / 100) * H };
          });
          if (layout === 'legacy') {
            drawTextOnBezierLegacy(ctx, M.items, M.widths, M.total, {
              P,
              fontPx: fs,
              fill: (s.fill || FILL),
              weight: (s.weight || WGT),
              family: previewFont(s.font || FAM)
            });
          } else {
            drawTextOnBezierNatural(ctx, M.items, M.widths, {
              P,
              fontPx: fs,
              fill: (s.fill || FILL),
              weight: (s.weight || WGT),
              family: previewFont(s.font || FAM),
              scaleY: (s.scaleY ?? 1),
              anchor,
              overflow
            });
          }
        } else {
          const x = (s.xPct ?? 50) / 100 * W;
          const y = (s.yPct ?? 50) / 100 * H;
          ctx.translate(x, y);
          if (s.rotateDeg) ctx.rotate((s.rotateDeg * Math.PI) / 180);
          if (s.scaleY && s.scaleY !== 1) ctx.scale(1, s.scaleY);
          ctx.fillStyle = s.fill || FILL;
          ctx.textBaseline = 'middle';
          const { items, widths, total } = M;
          let startX = 0;
          const align = s.align || ALGN;
          if (align === 'center') startX = -total / 2;
          else if (align === 'right') startX = -total;
          let cx = startX;
          for (let k = 0; k < items.length; k++) {
            const ch = items[k];
            const wch = widths[k];
            ctx.fillText(ch, cx + wch / 2, 0);
            cx += wch;
          }
        }
        ctx.restore();
      });
      if (!isCurrentRender(nonce)) return;
      if ('toBlob' in canvas && typeof canvas.toBlob === 'function') {
        const blob = await new Promise(r => canvas.toBlob(r, 'image/jpeg', QUALITY));
        if (!isCurrentRender(nonce)) return;
        if (blob && typeof URL.createObjectURL === 'function') {
          if (EP.blobUrl) URL.revokeObjectURL(EP.blobUrl);
          EP.blobUrl = URL.createObjectURL(blob);
          if (EP.img) EP.img.src = EP.blobUrl;
        } else {
          if (EP.img) EP.img.src = canvas.toDataURL('image/jpeg', QUALITY);
        }
      } else {
        if (EP.img) EP.img.src = canvas.toDataURL('image/jpeg', QUALITY);
      }
      if (isCurrentRender(nonce)) {
        EP.lastKey = previewFontsReady ? key : null;
        markOutdated(false);
      }
    } catch (e) {
      if (!isCurrentRender(nonce)) return;
      console.error('[engraving-preview]', e);
      if (opts.resetIfEmpty) removeOverlay();
    } finally {
      if (busyNonce === nonce) {
        busyNonce = 0;
        const b = getBtn();
        if (b) b.disabled = false;
      }
    }
  }
  // --- Carousel Hooks ---
  function reattachOnly() {
    if (!EP.wrap) return;
    const st = String(EP.mediaId) === String(getActiveFeaturedMediaId())
      ? findVisibleMediaById(EP.mediaId)
      : null;
    if (st) attachToStage(st);
    else EP.wrap.remove();
  }
  function bindCarouselHooks() {
    const carousel = galleryCarousel();
    if (carousel === boundCarousel) return;
    if (boundCarousel) {
      boundCarousel.removeEventListener('carousel:settle', reattachOnly);
      boundCarousel.removeEventListener('carousel:filter', reattachOnly);
    }
    boundCarousel = carousel;
    if (!carousel) return;
    carousel.addEventListener('carousel:settle', reattachOnly, { passive: true });
    carousel.addEventListener('carousel:filter', reattachOnly, { passive: true });
  }
  // MYCLUSIV-OPTIMIERUNG: Mehrere DOM-/Medienereignisse in einem Frame zusammenfassen.
  function scheduleReattach(fromDom = false) {
    refreshVariantFromDom = refreshVariantFromDom || fromDom;
    if (destroyed || refreshFrame !== null) return;
    refreshFrame = requestAnimationFrame(() => {
      refreshFrame = null;
      if (!getUi()) { destroy(); return; }
      if (refreshVariantFromDom) latestVariant = activeVariantDataFromDom() || latestVariant;
      refreshVariantFromDom = false;
      bindCarouselHooks();
      if (EP.active) ensureObserver();
      reattachOnly();
      setButtonState(EP.active ? 'update' : 'create');
    });
  }
  const onBtnClick = async (event) => {
    if (destroyed) return;
    if (!getUi()) { destroy(); return; }
    // MYCLUSIV: Ein Close-Klick schließt ausschließlich diese Vorschau und nur einmal.
    if (EP.closeBtn && EP.closeBtn.contains(event.target)) { removeOverlay(); return; }
    const target = event.target.closest?.('.engraving-preview-btn');
    if (!target || !getUi().contains(target) || target.disabled) return;
    if (EP.wrap && String(EP.mediaId) !== String(getActiveFeaturedMediaId())) removeOverlay();
    const nonce = ++renderNonce;
    busyNonce = nonce;
    target.disabled = true;
    ensureOverlay();
    bindCarouselHooks();
    const mountTarget = await goToActiveFeaturedMedia();
    if (!isCurrentRender(nonce)) return;
    if (!mountTarget) { removeOverlay(); return; }
    attachToStage(mountTarget);
    revealMedia(mountTarget);
    twoFrames(() => {
      if (!isCurrentRender(nonce)) return;
      reattachOnly();
      renderPreview({ resetIfEmpty: true, nonce });
    });
  };
  const onKeydown = (event) => {
    if (event.key === 'Escape' && EP.wrap) removeOverlay();
  };
  const onInput = (event) => {
    const input = event.target;
    if (!productScope()?.contains(input) || !input.matches?.('input[name^="properties["], textarea[name^="properties["]')) return;
    if (busyNonce) cancelRender();
    if (EP.active) markOutdated(true);
  };
  const onVariantChange = (event) => {
    if (!getUi()) { destroy(); return; }
    const variant = event.detail?.variant;
    if (!variant || !VARIANT_IDS.has(String(variant.id))) return;
    const sourceForm = event.target.closest?.('form');
    const expectedForm = productFormId();
    if (sourceForm && expectedForm && sourceForm.getAttribute('id') !== expectedForm) return;
    latestVariant = variant;
    cancelRender();
    if (EP.active) markOutdated(true);
    reattachOnly();
    scheduleReattach();
  };
  function belongsToSection(event) {
    const sectionId = event.detail?.sectionId;
    if (sectionId != null) return String(sectionId) === String(SECTION_ID);
    return event.target === document || hostSection()?.contains(event.target);
  }
  const onMediaChange = (event) => {
    if (belongsToSection(event)) scheduleReattach();
  };
  const onRerender = (event) => {
    if (!belongsToSection(event)) return;
    cancelRender();
    if (EP.active) markOutdated(true);
    scheduleReattach(true);
  };
  const onExternalClose = (event) => {
    if (event.detail?.sectionId != null && String(event.detail.sectionId) !== String(SECTION_ID)) return;
    removeOverlay();
  };
  const onSectionUnload = (event) => {
    if (belongsToSection(event)) destroy();
  };
  const onReady = () => scheduleReattach(true);
  function destroy() {
    if (destroyed) return;
    destroyed = true;
    removeOverlay();
    if (refreshFrame !== null) cancelAnimationFrame(refreshFrame);
    if (boundCarousel) {
      boundCarousel.removeEventListener('carousel:settle', reattachOnly);
      boundCarousel.removeEventListener('carousel:filter', reattachOnly);
    }
    imgCache.clear();
    document.removeEventListener('click', onBtnClick, true);
    document.removeEventListener('keydown', onKeydown);
    document.removeEventListener('input', onInput);
    document.removeEventListener('change', onInput);
    document.removeEventListener('variant:change', onVariantChange);
    document.removeEventListener('media:changed', onMediaChange);
    document.removeEventListener('product:media:changed', onMediaChange);
    document.removeEventListener('engraving-preview:close', onExternalClose);
    document.removeEventListener('product:rerender', onRerender, true);
    document.removeEventListener('shopify:section:load', onRerender);
    document.removeEventListener('shopify:section:unload', onSectionUnload);
    document.removeEventListener('DOMContentLoaded', onReady);
    if (window[HANDLER_KEY]?.destroy === destroy) {
      delete window[HANDLER_KEY];
      delete window[KEY];
    }
  }
  window[HANDLER_KEY] = { destroy };
  bindCarouselHooks();
  setButtonState('create');
  document.addEventListener('click', onBtnClick, { capture: true, passive: true });
  document.addEventListener('keydown', onKeydown, { passive: true });
  document.addEventListener('input', onInput, { passive: true });
  document.addEventListener('change', onInput, { passive: true });
  document.addEventListener('variant:change', onVariantChange, { passive: true });
  document.addEventListener('media:changed', onMediaChange, { passive: true });
  document.addEventListener('product:media:changed', onMediaChange, { passive: true });
  document.addEventListener('engraving-preview:close', onExternalClose, { passive: true });
  document.addEventListener('product:rerender', onRerender, true);
  document.addEventListener('shopify:section:load', onRerender);
  document.addEventListener('shopify:section:unload', onSectionUnload);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });

        this._destroy = destroy;
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this._destroy?.();
          this._destroy = null;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["engraving-symbols"] && !Shopify.designMode) return;
  try {
    // MYCLUSIV: Auch nach Section-Austausch initialisieren und entfernte Instanzen abbauen.
  if (!customElements.get('myc-engraving-symbols')) {
    customElements.define('myc-engraving-symbols', class extends HTMLElement {
      connectedCallback() {
        if (this._destroy) return;

  'use strict';
  const home = this;
  const toolbar = home.querySelector('.es-toolbar');
  const section = home.closest('.shopify-section') || home.parentElement;
  if (!toolbar || !section) return;

  // MYCLUSIV-OPTIMIERUNG: Ein Controller pro Section, auch nach erneuter Initialisierung.
  const controllers = window.myclusivSymbolControllers || (window.myclusivSymbolControllers = new Map());
  const key = home.dataset.sectionId;
  if (controllers.has(key)) controllers.get(key).destroy();
  const pop = toolbar.querySelector('[data-es-pop]');
  const more = toolbar.querySelector('[data-es-more]');
  const tabs = Array.from(toolbar.querySelectorAll('[role="tab"]'));
  const grids = Array.from(toolbar.querySelectorAll('[data-grid]'));
  const recentBox = toolbar.querySelector('[data-es-recent]');
  const recentRow = toolbar.querySelector('[data-es-recent-row]');
  const showRecents = toolbar.dataset.esShowRecents !== 'false';
  const storageKey = 'engraving_recent_emojis';
  const limitMessage = home.dataset.limitMessage;
  const listeners = [];
  const limitTimers = new Map();
  const validationMessages = new Map();
  const keywords = /gravur|engrave|engraving|bead|perle|zeile|seite|vorder|r[üu]ck|front|back/i;
  const segmenter = typeof Intl.Segmenter === 'function' ? new Intl.Segmenter(undefined, {granularity: 'grapheme'}) : null;
  let activeInput = null;
  let pointerField = null;
  let pointerInProgress = false;
  let recents = [];
  let frame = 0;

  function listen(target, type, handler, capture = false) {
    target.addEventListener(type, handler, capture);
    listeners.push(() => target.removeEventListener(type, handler, capture));
  }
  function isField(input) {
    if (!input || !section.contains(input) || !input.matches('input[type="text"],input:not([type]),textarea')) return false;
    return input.hasAttribute('data-engraving-input') || /-customize$/.test(input.id) || !!input.closest('#customize-fields') ||
      keywords.test([input.id, input.name, input.placeholder, input.getAttribute('aria-label'),
        ...Array.from(input.labels || [], label => label.textContent)].join(' '));
  }
  function usable(input) {
    return isField(input) && input.isConnected && !input.disabled && !input.readOnly &&
      !input.closest('[hidden],.hidden');
  }
  function maximum(input) {
    if (window.myclusivEngravingLength?.managed(input)) {
      window.myclusivEngravingLength.prepare(input);
      return window.myclusivEngravingLength.maximum(input);
    }
    const raw = input.getAttribute('maxlength') ?? input.getAttribute('data-maxlength') ?? input.getAttribute('data-max-chars');
    const value = raw === null ? NaN : Number(raw);
    return Number.isInteger(value) && value >= 0 ? value : Infinity;
  }
  function parts(text) {
    return segmenter ? Array.from(segmenter.segment(text), part => part.segment) : Array.from(text);
  }
  function units(text, input) {
    if (window.myclusivEngravingLength?.managed(input)) return window.myclusivEngravingLength.count(text);
    return input.hasAttribute('maxlength') ? text.length : parts(text).length;
  }
  function shorten(text, max, input) {
    if (window.myclusivEngravingLength?.managed(input)) return window.myclusivEngravingLength.shorten(text, max);
    const segments = parts(text);
    if (!input.hasAttribute('maxlength')) return segments.slice(0, max).join('');
    let result = '';
    for (const part of segments) {
      if (result.length + part.length > max) break;
      result += part;
    }
    return result;
  }
  function flash(input) {
    clearTimeout(limitTimers.get(input));
    input.classList.add('es-limit');
    limitTimers.set(input, setTimeout(() => {
      input.classList.remove('es-limit');
      limitTimers.delete(input);
    }, 250));
  }
  function clearValidation(input) {
    if (!validationMessages.has(input)) return;
    if (input.validationMessage === validationMessages.get(input)) input.setCustomValidity('');
    validationMessages.delete(input);
  }
  function enforce(event) {
    const input = event.target;
    if (!usable(input) || event.isComposing) return;
    const max = maximum(input);
    const changed = max !== Infinity && units(input.value, input) > max;
    if (changed) {
      input.value = shorten(input.value, max, input);
      flash(input);
    }
    clearValidation(input);
    if (changed && event.type !== 'input') input.dispatchEvent(new Event('input', {bubbles: true}));
  }
  function closeMore() {
    if (pop.hidden) return;
    pop.hidden = true;
    more.setAttribute('aria-expanded', 'false');
  }
  function park() {
    closeMore();
    toolbar.classList.remove('es-toolbar--visible');
    if (toolbar.parentElement !== home) home.appendChild(toolbar);
    activeInput = null;
  }
  function focusField(event) {
    const input = event.target;
    if (toolbar.contains(input)) return;
    if (!usable(input)) {
      if (!pointerInProgress && !section.contains(input)) park();
      return;
    }
    if (activeInput !== input) closeMore();
    activeInput = input;
    const wrapper = input.closest('[data-engraving-wrapper],.customize-line,.engraving-field,.form-control,.product-form__input,.field,.form__field,.product-option,.customize-item,.customize-field,.product-option-block,.form-field') || input.parentElement;
    if (toolbar.parentElement !== wrapper) wrapper.appendChild(toolbar);
    toolbar.classList.add('es-toolbar--visible');
  }
  function selectTab(tab) {
    for (const item of tabs) {
      const selected = item === tab;
      item.setAttribute('aria-selected', String(selected));
      item.tabIndex = selected ? 0 : -1;
    }
    for (const grid of grids) grid.hidden = grid.dataset.grid !== tab.dataset.cat;
  }
  function renderRecents() {
    recentBox.hidden = !showRecents || recents.length === 0;
    recentRow.textContent = '';
    for (const symbol of recents) {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'es-btn es-emoji';
      button.dataset.emoji = symbol;
      button.textContent = symbol;
      recentRow.appendChild(button);
    }
  }
  function remember(symbol) {
    if (!showRecents) return;
    recents = [symbol, ...recents.filter(item => item !== symbol)].slice(0, 4);
    try { localStorage.setItem(storageKey, JSON.stringify(recents)); } catch (_) {}
    renderRecents();
  }
  if (showRecents) {
    try {
      const stored = JSON.parse(localStorage.getItem(storageKey) || '[]');
      if (Array.isArray(stored)) recents = [...new Set(stored.filter(item => typeof item === 'string' && item.length > 0 && item.length <= 32))].slice(0, 4);
    } catch (_) {}
    renderRecents();
  }

  listen(toolbar, 'click', event => {
    const button = event.target.closest('button');
    if (!button || !toolbar.contains(button)) return;
    if (button === more) {
      pop.hidden = !pop.hidden;
      more.setAttribute('aria-expanded', String(!pop.hidden));
      return;
    }
    if (button.dataset.cat) { selectTab(button); return; }
    const symbol = button.dataset.emoji;
    const input = activeInput;
    if (!symbol || !usable(input)) { park(); return; }
    const start = input.selectionStart ?? input.value.length;
    const end = input.selectionEnd ?? start;
    const next = input.value.slice(0, start) + symbol + input.value.slice(end);
    if (units(next, input) > maximum(input)) { flash(input); return; }
    input.value = next;
    try { input.focus({preventScroll: true}); } catch (_) { input.focus(); }
    input.setSelectionRange(start + symbol.length, start + symbol.length);
    // MYCLUSIV: Ein Input-Event aktualisiert Zähler, Speicherung und Gravurvorschau.
    input.dispatchEvent(new Event('input', {bubbles: true}));
    remember(symbol);
  });
  listen(toolbar, 'keydown', event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      closeMore();
      more.focus();
      return;
    }
    const index = tabs.indexOf(event.target);
    if (index < 0) return;
    let next = index;
    if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;
    event.preventDefault();
    selectTab(tabs[next]);
    tabs[next].focus();
  });
  listen(document, 'focusin', focusField);
  listen(document, 'pointerdown', event => {
    pointerInProgress = true;
    const target = event.target;
    const label = target.closest('label');
    const input = usable(target) ? target : label?.control;
    pointerField = usable(input) ? input : null;
  }, true);
  listen(document, 'pointercancel', () => { pointerField = null; pointerInProgress = false; }, true);
  listen(document, 'keydown', () => { pointerInProgress = false; }, true);
  listen(document, 'click', event => {
    pointerInProgress = false;
    const target = event.target;
    const pressedField = pointerField;
    pointerField = null;
    if (toolbar.contains(target)) return;
    if (usable(target)) {
      focusField({target});
      return;
    }
    const label = target.closest('label');
    if (label && usable(label.control)) return;
    if (usable(pressedField) && document.activeElement === pressedField) {
      focusField({target: pressedField});
      return;
    }
    if (!section.contains(target)) park();
  });
  // MYCLUSIV-OPTIMIERUNG: Korrektur vor den Input-Listenern von Zähler und Speicherung.
  listen(document, 'input', enforce, true);
  listen(document, 'change', enforce, true);
  listen(document, 'compositionend', enforce, true);
  listen(document, 'submit', event => {
    const form = event.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    for (const input of Array.from(form.elements)) {
      if (!usable(input) || units(input.value, input) <= maximum(input)) continue;
      event.preventDefault();
      event.stopImmediatePropagation();
      const message = limitMessage.replace('__MAX__', maximum(input));
      input.setCustomValidity(message);
      validationMessages.set(input, message);
      input.reportValidity();
      return;
    }
  }, true);
  function checkAfterChange() {
    cancelAnimationFrame(frame);
    frame = requestAnimationFrame(() => {
      frame = 0;
      if (!usable(activeInput)) park();
    });
  }
  // MYCLUSIV: Prestige ersetzt Produktbereiche synchron nach diesem Event.
  listen(document, 'product:rerender', event => {
    if (!section.contains(event.target)) return;
    park();
    checkAfterChange();
  }, true);
  listen(document, 'variant:change', event => {
    if (section.contains(event.target)) checkAfterChange();
  });
  listen(document, 'shopify:section:unload', event => {
    if (event.target === section || String(event.detail?.sectionId) === String(key)) destroy();
  });
  function destroy() {
    pointerField = null;
    pointerInProgress = false;
    for (const remove of listeners) remove();
    cancelAnimationFrame(frame);
    for (const [input, timer] of limitTimers) {
      clearTimeout(timer);
      input.classList.remove('es-limit');
    }
    for (const input of validationMessages.keys()) clearValidation(input);
    park();
    if (controllers.get(key)?.destroy === destroy) controllers.delete(key);
  }
  controllers.set(key, {destroy});
  if (usable(document.activeElement)) focusField({target: document.activeElement});

        this._destroy = destroy;
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this._destroy?.();
          this._destroy = null;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-sidebar"] && !Shopify.designMode) return;
  try {
    (() => {
    function initializeAccount(sidebar) {
      for (const template of sidebar.querySelectorAll('template[data-myc-sidebar-account]')) {
        template.replaceWith(template.content.cloneNode(true));
      }
    }

    document.addEventListener('dialog:before-show', event => {
      if (event.target instanceof Element && event.target.matches('header-sidebar')) {
        initializeAccount(event.target);
      }
    }, true);

    for (const sidebar of document.querySelectorAll('header-sidebar[open]')) {
      initializeAccount(sidebar);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["myclusiv-header-account"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('myclusiv-header-account')) return;
    class MyclusivHeaderAccount extends HTMLElement {
      connectedCallback() {
        this.media = window.matchMedia('(min-width: 700px)');
        this.activate = () => {
          if (!this.media.matches || this.waiting || !this.querySelector('template')) return;
          this.waiting = true;
          customElements.whenDefined('shopify-account').then(() => {
            const template = this.querySelector('template');
            if (!this.isConnected || !this.media.matches || !template) return;
            template.replaceWith(template.content.cloneNode(true));
            this.querySelector('[data-myc-account-fallback]')?.remove();
          }).finally(() => { this.waiting = false; });
        };
        if (this.media.addEventListener) this.media.addEventListener('change', this.activate);
        else this.media.addListener(this.activate);
        this.activate();
      }
      disconnectedCallback() {
        if (this.media?.removeEventListener) this.media.removeEventListener('change', this.activate);
        else this.media?.removeListener(this.activate);
      }
    }
    customElements.define('myclusiv-header-account', MyclusivHeaderAccount);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["myclusiv-product-promo"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('myc-product-promo')) {
  customElements.define('myc-product-promo', class extends HTMLElement {
    connectedCallback() {
      if (this._listening) return;
      this._listening = true;
      this._epoch = (this._epoch || 0) + 1;
      this._click = this._click || this._onClick.bind(this);
      this.addEventListener('click', this._click);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._click);
      this._listening = false;
      this._copying = false;
      this._epoch = (this._epoch || 0) + 1;
      clearTimeout(this._overlayTimer);
      this.classList.remove('mcl-promo--show');
      const overlay = this.querySelector('.mcl-promo__overlay');
      if (overlay) overlay.textContent = '';
    }

    async _copy(code) {
      if (navigator.clipboard?.writeText) {
        try {
          await navigator.clipboard.writeText(code);
          return;
        } catch {}
      }
      const previousFocus = document.activeElement;
      const textarea = document.createElement('textarea');
      textarea.value = code;
      textarea.readOnly = true;
      textarea.style.cssText = 'position:fixed;inset-inline-start:-9999px;inset-block-start:0;';
      document.body.appendChild(textarea);
      try {
        textarea.select();
        if (!document.execCommand?.('copy')) throw new Error('Copy failed');
      } finally {
        textarea.remove();
        if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
      }
    }

    async _onClick(event) {
      const button = event.target.closest('.mcl-promo__chip');
      if (!button || !this.contains(button) || this._copying) return;
      const code = button.dataset.code;
      if (!code) return;
      const epoch = this._epoch;
      this._copying = true;
      try {
        await this._copy(code);
        if (!this.isConnected || this._epoch !== epoch) return;
        const overlay = this.querySelector('.mcl-promo__overlay');
        if (!overlay) return;
        overlay.textContent = button.dataset.msg || code;
        this.classList.add('mcl-promo--show');
        clearTimeout(this._overlayTimer);
        this._overlayTimer = setTimeout(() => {
          this.classList.remove('mcl-promo--show');
          overlay.textContent = '';
        }, 4000);
      } catch {
        if (!this.isConnected || this._epoch !== epoch) return;
        const label = button.querySelector('.mcl-promo__code');
        if (label) {
          const range = document.createRange();
          range.selectNodeContents(label);
          const selection = window.getSelection();
          selection?.removeAllRanges();
          selection?.addRange(range);
        }
      } finally {
        if (this._epoch === epoch) this._copying = false;
      }
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-info"] && !Shopify.designMode) return;
  try {
    (function () {
      if (window.myclusivStandardFieldCounters) {
        window.myclusivStandardFieldCounters.refresh(document);
        return;
      }

      var rootSelector = '[data-myclusiv-standard-counters]';
      var refreshQueued = false;

      function updateCounter(span, root) {
        var input = document.getElementById(span.getAttribute('data-counter-for'));
        if (!input || !root.contains(input)) return;

        var max = parseInt(span.getAttribute('data-max') || input.getAttribute('maxlength') || '0', 10);
        if (!(max > 0)) {
          span.hidden = true;
          return;
        }

        span.hidden = false;
        var length = window.myclusivEngravingLength;
        var weighted = length && length.managed(input);
        if (weighted) length.prepare(input);
        var text = (weighted ? length.count(input.value || '') : (input.value || '').length) + ' / ' + max + ' ' + root.getAttribute('data-myclusiv-standard-counters');
        if (span.textContent !== text) span.textContent = text;
      }

      function refreshRoot(root) {
        var counters = root.querySelectorAll('[data-counter-for]');
        for (var i = 0; i < counters.length; i++) updateCounter(counters[i], root);
      }

      function refresh(scope) {
        scope = scope || document;
        if (scope.matches && scope.matches(rootSelector)) refreshRoot(scope);

        var roots = scope.querySelectorAll(rootSelector);
        for (var i = 0; i < roots.length; i++) refreshRoot(roots[i]);
      }

      function scheduleRefresh() {
        if (refreshQueued) return;
        refreshQueued = true;
        window.requestAnimationFrame(function () {
          refreshQueued = false;
          refresh(document);
        });
      }

      document.addEventListener('input', function (event) {
        var input = event.target;
        if (!input || !input.id || !input.closest) return;

        var root = input.closest(rootSelector);
        if (!root) return;

        var counters = root.querySelectorAll('[data-counter-for]');
        for (var i = 0; i < counters.length; i++) {
          if (counters[i].getAttribute('data-counter-for') === input.id) updateCounter(counters[i], root);
        }
      });

      document.addEventListener('variant:change', scheduleRefresh);
      document.addEventListener('product:rerender', scheduleRefresh, true);
      document.addEventListener('shopify:section:load', function (event) {
        refresh(event.target);
      });

      window.myclusivStandardFieldCounters = { refresh: refresh };

      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
          refresh(document);
        }, { once: true });
      } else {
        refresh(document);
      }
    })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["variant-picker-customize"] && !Shopify.designMode) return;
  try {
    if (!window.myclusivEngravingStorage) {
    window.myclusivEngravingStorage = (() => {
      const prefix = 'engrave:';
      const ttl = 24 * 60 * 60 * 1000;
      let expiryTimer;

      function valuesOnly(input) {
        const values = Object.create(null);
        if (!input || typeof input !== 'object' || Array.isArray(input)) return values;
        for (const key of Object.keys(input)) {
          if (/^(?:[1-9]|10)$/.test(key) && typeof input[key] === 'string' && input[key].length <= 1024) {
            values[key] = input[key];
          }
        }
        return values;
      }

      function parse(raw, now) {
        if (!raw || raw.length > 32768) return null;
        try {
          const saved = JSON.parse(raw);
          if (!saved || saved.version !== 1 || !Number.isFinite(saved.updatedAt) || saved.updatedAt <= 0 ||
              saved.updatedAt > now || saved.expiresAt !== saved.updatedAt + ttl || saved.expiresAt <= now) return null;
          const values = valuesOnly(saved.values);
          if (!Object.values(values).some(value => value.length > 0)) return null;
          return { values, updatedAt: saved.updatedAt, expiresAt: saved.expiresAt };
        } catch (_) {
          return null;
        }
      }

      function cleanup() {
        clearTimeout(expiryTimer);
        const now = Date.now();
        let nextExpiry = Infinity;
        try {
          const keys = [];
          for (let index = 0; index < localStorage.length; index++) {
            const key = localStorage.key(index);
            if (key && key.startsWith(prefix)) keys.push(key);
          }
          for (const key of keys) {
            const saved = parse(localStorage.getItem(key), now);
            if (saved) nextExpiry = Math.min(nextExpiry, saved.expiresAt);
            else localStorage.removeItem(key);
          }
        } catch (_) {}
        if (Number.isFinite(nextExpiry)) expiryTimer = setTimeout(cleanup, Math.max(1, nextExpiry - Date.now() + 1));
      }

      function read(key) {
        cleanup();
        if (!key.startsWith(prefix)) return null;
        try {
          return parse(localStorage.getItem(key), Date.now());
        } catch (_) {
          return null;
        }
      }

      function write(key, input, updatedAt) {
        if (!key.startsWith(prefix)) return false;
        const now = Date.now();
        const values = valuesOnly(input);
        try {
          if (!Number.isFinite(updatedAt) || updatedAt <= 0 || updatedAt > now || updatedAt + ttl <= now ||
              !Object.values(values).some(value => value.length > 0)) {
            localStorage.removeItem(key);
          } else {
            localStorage.setItem(key, JSON.stringify({ version: 1, updatedAt, expiresAt: updatedAt + ttl, values }));
          }
          cleanup();
          return true;
        } catch (_) {
          return false;
        }
      }

      window.addEventListener('pageshow', cleanup);
      window.addEventListener('focus', cleanup);
      window.addEventListener('storage', event => {
        if (event.key === null || event.key.startsWith(prefix)) cleanup();
      });
      cleanup();
      return { read, write };
    })();
  }

  // MYCLUSIV: Auch nach Section-Austausch initialisieren und entfernte Instanzen abbauen.
  if (!customElements.get('myc-customization-fields')) {
    customElements.define('myc-customization-fields', class extends HTMLElement {
      connectedCallback() {
        if (this._destroy) return;

        var picker = this.closest('variant-picker');
        if (!picker) return;

        var sectionId = this.dataset.sectionId;
        var productId = this.dataset.productId;
        var formId = this.dataset.formId;
        var counterWord = this.dataset.counterWord;
        var storageKey = 'engrave:' + productId + ':' + sectionId;
        var controllerKey = storageKey + ':' + formId;
        var controllers = window.myclusivCustomizeControllers;
        if (!controllers) controllers = window.myclusivCustomizeControllers = Object.create(null);
        var engravingStorage = window.myclusivEngravingStorage;
        var inheritedState = controllers[controllerKey] ? controllers[controllerKey].destroy() : null;
        var savedState = inheritedState || engravingStorage.read(storageKey);
        var store = savedState ? savedState.values : Object.create(null);
        var lastEditedAt = savedState ? savedState.updatedAt : 0;
        var restoring = false;

        var fields = null;
        var observer = null;
        var saveHandle = null;
        var frameHandle = null;
        var destroyed = false;
        var useIdle = typeof window.requestIdleCallback === 'function' && typeof window.cancelIdleCallback === 'function';
        var variantsByOptions = new Map();
        var variantIds = new Set();
        var countConfig = null;
        var activeVariant = null;
        var priceElements = [];
        var separator = '\u0001';
        var currency = 'EUR';
        var currencyFormatter;
        var amountFormatter;
        var lastSaved = JSON.stringify({ values: store, updatedAt: lastEditedAt });

        function getPicker() {
          if (picker && picker.isConnected && picker.dataset.myclusivProductId === String(productId)) return picker;
          var candidates = document.querySelectorAll('variant-picker');
          for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].getAttribute('form-id') === formId && candidates[i].getAttribute('section-id') === sectionId && candidates[i].dataset.myclusivProductId === String(productId)) {
              picker = candidates[i];
              return picker;
            }
          }
          return null;
        }

        function parseData(selector) {
          var element = picker.querySelector(selector);
          if (!element) return null;
          try { return JSON.parse(element.textContent); } catch (_) { return null; }
        }

        function cancelSave() {
          if (saveHandle === null) return;
          if (useIdle) window.cancelIdleCallback(saveHandle);
          else window.clearTimeout(saveHandle);
          saveHandle = null;
        }

        function save() {
          cancelSave();
          var serialized = JSON.stringify({ values: store, updatedAt: lastEditedAt });
          if (serialized === lastSaved) return;
          if (engravingStorage.write(storageKey, store, lastEditedAt)) lastSaved = serialized;
        }

        function scheduleSave() {
          cancelSave();
          saveHandle = useIdle ? window.requestIdleCallback(save, { timeout: 200 }) : window.setTimeout(save, 120);
        }

        // MYCLUSIV: Zeichenzähler direkt am zugehörigen Feld aktualisieren.
        function updateCounter(input, maxLength) {
          var line = input.closest('.customize-line');
          var counter = line && line.querySelector('[id="' + input.id.replace(/-customize$/, '-inputcounter') + '"]');
          if (!counter) return;
          var length = window.myclusivEngravingLength;
          if (length) length.prepare(input);
          var max = Number(maxLength) || (length ? length.maximum(input) : Math.max(0, input.maxLength || 0));
          counter.textContent = (length ? length.count(input.value) : input.value.length) + ' / ' + max + ' ' + counterWord;
        }

        function refreshCounter(fieldNumber, maxLength, inputElement) {
          if (destroyed || !getPicker()) return;
          var number = Number(fieldNumber);
          if (!Number.isInteger(number) || number < 1) return;
          var input = picker.querySelector('[id="' + number + '-customize"]');
          if (input && (!inputElement || inputElement === input)) updateCounter(input, maxLength);
        }

        function onInput(event) {
          if (event.isComposing) return;
          var input = event.target;
          var match = input.id && input.id.match(/^(\d+)-customize$/);
          if (!match) return;
          var value = input.value || '';
          if (store[match[1]] !== value) {
            store[match[1]] = value;
            if (!restoring) lastEditedAt = Date.now();
            scheduleSave();
          }
          updateCounter(input);
        }

        function setupPrices() {
          activeVariant = parseData('[data-variant]');
          variantsByOptions.clear();
          variantIds.clear();
          countConfig = parseData('[data-engraving-count-config]');
          priceElements = picker.querySelectorAll('[data-engraving-price-difference]');
          var variants = parseData('[data-variant-price-data]');
          if (!Array.isArray(variants) || !countConfig || !Array.isArray(countConfig.values)) return;
          variants.forEach(function (variant) {
            if (!variant || !Array.isArray(variant.options)) return;
            variantsByOptions.set(variant.options.join(separator), variant);
            variantIds.add(String(variant.id));
          });
          currency = (picker.dataset.currency || 'EUR').toUpperCase();
          var locale = picker.dataset.locale || document.documentElement.lang || undefined;
          try {
            currencyFormatter = new Intl.NumberFormat(locale, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
            amountFormatter = new Intl.NumberFormat(locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
          } catch (_) {
            currencyFormatter = new Intl.NumberFormat(undefined, { style: 'currency', currency: currency, minimumFractionDigits: 0, maximumFractionDigits: 2 });
            amountFormatter = new Intl.NumberFormat(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 2 });
          }
        }

        function updatePrices(variant) {
          if (!variant || !Array.isArray(variant.options) || !countConfig || !countConfig.values.length) return;
          var optionIndex = Number(countConfig.optionPosition) - 1;
          if (optionIndex < 0 || optionIndex >= variant.options.length) return;
          var baseOptions = variant.options.slice();
          baseOptions[optionIndex] = countConfig.values[0];
          var baseVariant = variantsByOptions.get(baseOptions.join(separator));
          for (var i = 0; i < priceElements.length; i++) {
            var element = priceElements[i];
            var options = variant.options.slice();
            options[optionIndex] = element.dataset.engravingCountValue;
            var targetVariant = variantsByOptions.get(options.join(separator));
            var difference = baseVariant && targetVariant ? Number(targetVariant.price) - Number(baseVariant.price) : NaN;
            var text = '';
            if (Number.isFinite(difference)) {
              if (difference === 0) text = element.dataset.engravingIncludedLabel || '';
              else {
                var amount = Math.abs(difference) / 100;
                text = (difference > 0 ? '+' : '−') + (currency === 'EUR' ? amountFormatter.format(amount) + '€' : currencyFormatter.format(amount));
              }
            }
            element.hidden = !text;
            if (element.textContent !== text) element.textContent = text;
          }
        }

        function bindFields() {
          var currentFields = picker.querySelector('#customize-fields');
          if (currentFields === fields) return;
          if (fields) {
            fields.removeEventListener('input', onInput);
            fields.removeEventListener('change', onInput);
          }
          if (observer) observer.disconnect();
          fields = currentFields;
          if (!fields) return;
          fields.addEventListener('input', onInput);
          fields.addEventListener('change', onInput);
          if ('MutationObserver' in window) {
            observer = new MutationObserver(scheduleRefresh);
            observer.observe(fields, { childList: true });
          }
        }

        function refresh(variant) {
          if (destroyed || !getPicker()) return;
          bindFields();
          variant = variant || activeVariant || parseData('[data-variant]');
          activeVariant = variant;
          if (fields) {
            var inputs = fields.querySelectorAll('input[id$="-customize"]');
            var count = variant && Array.isArray(variant.options) ? parseInt(variant.options[1], 10) : NaN;
            for (var i = 0; i < inputs.length; i++) {
              var input = inputs[i];
              if (window.myclusivEngravingLength) window.myclusivEngravingLength.prepare(input);
              var match = input.id.match(/^(\d+)-customize$/);
              if (!match) continue;
              var value = store[match[1]];
              if (typeof value === 'string' && input.value !== value) {
                input.value = window.myclusivEngravingLength
                  ? window.myclusivEngravingLength.shorten(value, window.myclusivEngravingLength.maximum(input)) : value;
                restoring = true;
                try { input.dispatchEvent(new Event('input', { bubbles: true })); }
                finally { restoring = false; }
              }
              store[match[1]] = input.value || '';
              if (Number.isFinite(count)) {
                var visible = Number(match[1]) <= count;
                input.closest('.customize-line').classList.toggle('hidden', !visible);
                input.disabled = !visible;
                input.required = visible;
              }
              updateCounter(input);
            }
          }
          updatePrices(variant);
        }

        function scheduleRefresh() {
          if (destroyed || frameHandle !== null) return;
          frameHandle = window.requestAnimationFrame(function () {
            frameHandle = null;
            var previousPicker = picker;
            if (!getPicker()) { destroy(); return; }
            if (picker !== previousPicker) setupPrices();
            refresh();
          });
        }

        function onVariantChange(event) {
          var variant = event.detail && event.detail.variant;
          if (!variant) return;
          var sourceForm = event.target.closest && event.target.closest('form');
          if (sourceForm ? sourceForm.getAttribute('id') !== formId : !variantIds.has(String(variant.id))) return;
          var previousPicker = picker;
          if (!getPicker()) { destroy(); return; }
          if (picker !== previousPicker) setupPrices();
          refresh(variant);
          scheduleRefresh();
        }

        function onSectionUnload(event) {
          if (event.detail && String(event.detail.sectionId) === sectionId) destroy();
        }

        function destroy() {
          if (destroyed) return { values: store, updatedAt: lastEditedAt };
          destroyed = true;
          save();
          if (frameHandle !== null) window.cancelAnimationFrame(frameHandle);
          if (observer) observer.disconnect();
          if (fields) {
            fields.removeEventListener('input', onInput);
            fields.removeEventListener('change', onInput);
          }
          document.removeEventListener('DOMContentLoaded', scheduleRefresh);
          document.removeEventListener('variant:change', onVariantChange);
          document.removeEventListener('product:rerender', scheduleRefresh, true);
          document.removeEventListener('shopify:section:load', scheduleRefresh);
          document.removeEventListener('shopify:section:unload', onSectionUnload);
          window.removeEventListener('pagehide', save);
          delete controllers[controllerKey];
          return { values: store, updatedAt: lastEditedAt };
        }

        controllers[controllerKey] = { destroy: destroy, updateCounter: refreshCounter };
        // MYCLUSIV: Bestehende externe Aufrufe unterstützen; jeder Controller liest seine eigenen Felder.
        window.checkCustomizeField = function (fieldNumber, maxLength, inputElement) {
          var currentControllers = window.myclusivCustomizeControllers || {};
          Object.keys(currentControllers).forEach(function (key) {
            var controller = currentControllers[key];
            if (typeof controller.updateCounter === 'function') controller.updateCounter(fieldNumber, maxLength, inputElement);
          });
        };
        setupPrices();
        refresh();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scheduleRefresh, { once: true });
        document.addEventListener('variant:change', onVariantChange);
        document.addEventListener('product:rerender', scheduleRefresh, true);
        document.addEventListener('shopify:section:load', scheduleRefresh);
        document.addEventListener('shopify:section:unload', onSectionUnload);
        window.addEventListener('pagehide', save);

        this._destroy = destroy;
      }
      disconnectedCallback() {
        queueMicrotask(() => {
          if (this.isConnected) return;
          this._destroy?.();
          this._destroy = null;
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
